
import { Provider, ErrorBoundary } from '@rollbar/react';
import { rollbar } from './rollbarconfig';

const GlobalErrorBoundary: React.FC<React.PropsWithChildren<{}>> = props => {
  return <ErrorBoundary>{props.children}</ErrorBoundary>;
};

export const RollbarProvider: React.FC<React.PropsWithChildren<{}>> = props => (
  <Provider instance={rollbar}>
    <GlobalErrorBoundary>{props.children}</GlobalErrorBoundary>
  </Provider>
);
